import { render, staticRenderFns } from "./ServicesAreas.vue?vue&type=template&id=fad90804&scoped=true"
import script from "./ServicesAreas.vue?vue&type=script&lang=js"
export * from "./ServicesAreas.vue?vue&type=script&lang=js"
import style0 from "./ServicesAreas.vue?vue&type=style&index=0&id=fad90804&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fad90804",
  null
  
)

export default component.exports